import createEditEventRedux from 'Modules/events/views/.components/createEditEvent/redux/reducer';
import deleteEventRedux from 'Modules/events/views/.components/deleteEvent/redux/reducer';
import unitTypeEventsRedux from 'Modules/events/.components/unitTypeEvents/redux/reducer';
import createEditUnitTypeEventRedux from 'Modules/events/.components/createEditUnitTypeEvent/redux/reducer';
import deleteUnitTypeEventRedux from 'Modules/events/.components/deleteUnitTypeEvent/redux/reducer'

//export redux objects
export default {
	createEditEventRedux,
	deleteEventRedux,
	unitTypeEventsRedux,
	createEditUnitTypeEventRedux,
	deleteUnitTypeEventRedux,
};